/* eslint-disable no-unused-vars */
import React from 'react';
import { NavLink } from 'react-router-dom';

import {
  UilCreateDashboard,
  UilUsersAlt,
  UilBell,
  UilBookmark,
  UilSuitcaseAlt,
  UilNewspaper,
  UilUniversity,
  UilBookAlt,
  UilCreditCard,
} from '@iconscout/react-unicons';

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const mMenu = [
  getItem(<NavLink to="/dashboard">Dashboard</NavLink>, 'dashboard', <UilCreateDashboard />, null, 'dashboard'),
  getItem(<NavLink to="/emp-trainings">EMP Trainings</NavLink>, 'trainings', <UilBookAlt />, null, 'trainings'),
  getItem(<NavLink to="/notifications">Notifications</NavLink>, 'notifications', <UilBell />, null, 'notifications'),
];

export default mMenu